// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.role-timeline-header[data-v-6002ba9b] {
  display: flex;
  height: 32px;
  user-select: none;
}
.role-timeline-header-name[data-v-6002ba9b] {
  width: 80px;
  flex: 0 0 80px;
  background: #fff;
  z-index: 2;
  position: sticky;
  left: 0;
}
.role-timeline-header-content[data-v-6002ba9b] {
  position: relative;
  flex: 1;
  min-width: 0;
}
.role-timeline-header-grid[data-v-6002ba9b] {
  position: relative;
  height: 100%;
  width: 100%;
  min-width: 1440px;
}
.role-timeline-header-label[data-v-6002ba9b] {
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  color: #69757d;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.role-timeline-header-label[data-v-6002ba9b]:first-child {
  transform: translateX(0);
}
.role-timeline-header-label[data-v-6002ba9b]:last-child {
  transform: translateX(-100%);
}

`, "",{"version":3,"sources":["webpack://./src/role/components/RoleTimeFooter.vue"],"names":[],"mappings":";AA0CA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,OAAO;AACT;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["<script setup lang=\"ts\">\nimport { computed } from \"vue\";\nimport { getRolePosition } from \"../roleTimeLayout\";\n\nconst props = defineProps<{\n  startHour: number;\n  endHour: number;\n}>();\n\nconst hours = computed<number[]>(() => {\n  const result: number[] = [];\n  const duration = props.endHour - props.startHour;\n  const step = 2 - (duration % 2);\n\n  for (let hour = props.startHour; hour <= props.endHour; hour += step) {\n    result.push(hour);\n  }\n\n  return result;\n});\n</script>\n\n<template>\n  <div class=\"role-timeline-header\">\n    <div class=\"role-timeline-header-content\">\n      <div class=\"role-timeline-header-grid\">\n        <div\n          v-for=\"hour in hours\"\n          :key=\"hour\"\n          class=\"role-timeline-header-label\"\n          :style=\"{\n            left: `${getRolePosition(hour, props.startHour, props.endHour)}%`,\n          }\"\n        >\n          {{ String(hour).padStart(2, \"0\") }}:00\n        </div>\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped>\n.role-timeline-header {\n  display: flex;\n  height: 32px;\n  user-select: none;\n}\n\n.role-timeline-header-name {\n  width: 80px;\n  flex: 0 0 80px;\n  background: #fff;\n  z-index: 2;\n  position: sticky;\n  left: 0;\n}\n\n.role-timeline-header-content {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n}\n\n.role-timeline-header-grid {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  min-width: 1440px;\n}\n\n.role-timeline-header-label {\n  position: absolute;\n  bottom: 0;\n  transform: translateX(-50%);\n  color: #69757d;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.role-timeline-header-label:first-child {\n  transform: translateX(0);\n}\n\n.role-timeline-header-label:last-child {\n  transform: translateX(-100%);\n}\n\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
